// Plays short audio clips for any `data-action="play-clip"` button, wherever it
// appears (search results, episode sections, quotes, references).
//
// Buttons are rendered by ApplicationHelper#play_clip_button and carry
// data-episode-id, data-starts and data-ends. Handling is delegated from the
// document so buttons rendered after load still work, and so this runs whether
// or not the pack is evaluated before the body.

const PLAYING_CLASS = "text-seek-darker";
const IDLE_CLASS = "text-gray-400";

let audio = null;
let playingButton = null;

function icon(button, name) {
  return button.querySelector(`[data-icon='${name}']`);
}

// The ring is drawn by shortening the dash gap of a circle stroked with a
// single dash the length of its own circumference.
function setProgress(button, fraction) {
  const ring = icon(button, "progress");
  if (!ring) return;

  const circle = ring.querySelector("circle");
  if (!circle) return;

  const circumference = parseFloat(circle.dataset.circumference);
  const clamped = Math.min(Math.max(fraction, 0), 1);

  circle.setAttribute("stroke-dashoffset", circumference * (1 - clamped));
}

function setPlaying(button, playing) {
  if (!button) return;

  button.classList.toggle(PLAYING_CLASS, playing);
  button.classList.toggle(IDLE_CLASS, !playing);

  // Show the stop square and the progress ring while this clip is playing.
  const play = icon(button, "play");
  const stop = icon(button, "stop");
  const progress = icon(button, "progress");

  if (play) play.classList.toggle("hidden", playing);
  if (stop) stop.classList.toggle("hidden", !playing);
  if (progress) progress.classList.toggle("hidden", !playing);

  if (!playing) setProgress(button, 0);
}

function stop() {
  if (audio) {
    audio.pause();
    audio = null;
  }

  setPlaying(playingButton, false);
  playingButton = null;
}

// The clip's own length, so the ring completes exactly as the clip ends even
// before metadata has loaded.
function clipLength(button) {
  const length = parseFloat(button.dataset.ends) - parseFloat(button.dataset.starts);

  return isFinite(length) && length > 0 ? length : null;
}

function play(button) {
  const { episodeId, starts, ends } = button.dataset;

  stop();

  audio = new Audio(`/clip/${episodeId}/${starts}/${ends}`);
  playingButton = button;

  audio.onplaying = function () {
    setPlaying(button, true);
  };

  audio.ontimeupdate = function () {
    const length = isFinite(audio.duration) && audio.duration > 0 ? audio.duration : clipLength(button);

    if (length) setProgress(button, audio.currentTime / length);
  };

  audio.onended = stop;
  audio.onerror = stop;

  audio.play();
}

document.addEventListener("click", function (event) {
  const button = event.target.closest("button[data-action='play-clip']");

  if (!button) return;

  event.preventDefault();

  // Clicking the button that is already playing stops it.
  if (button === playingButton) {
    stop();
  } else {
    play(button);
  }
});
